import { userService } from '@/services/user.service'
import { useAuthStore } from '@/stores/auth.store'
import { useQuery } from '@tanstack/react-query'

export type { SessionState } from '@/types'

export const sessionStateKeys = {
  all: ['session-state'] as const,
}

export function useSessionState() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  return useQuery({
    queryKey: sessionStateKeys.all,
    queryFn: () => userService.getSessionState(),
    enabled: isAuthenticated,
    staleTime: 30_000,
  })
}
